'use strict';

var React = require('react');
var HCAvatar = require('./HCAvatar.js');
require('prop-types');
var IconButton = require('../../node_modules/@material-ui/core/esm/IconButton/IconButton.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function AvatarButton(_ref) {
  var avatarUrl = _ref.avatarUrl,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      onButtonClick = _ref.onButtonClick;
  return React__default["default"].createElement(IconButton["default"], {
    onClick: function onClick(event) {
      onButtonClick(event.currentTarget);
    }
  }, React__default["default"].createElement(HCAvatar, {
    avatarUrl: avatarUrl,
    firstName: firstName,
    lastName: lastName
  }));
}

AvatarButton.defaultProps = {
  avatarUrl: '',
  firstName: '',
  lastName: '',
  onButtonClick: function onButtonClick() {}
};

module.exports = AvatarButton;
